/* eslint-disable object-shorthand */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable vars-on-top */
/* eslint-disable strict */
/* eslint-disable no-var */
/* eslint-disable complexity */

(function (algolia) {
    'use strict';
    if (!algolia || !algolia.externals || !algolia.externals.instantsearch) return;
    var instantsearch = algolia.externals.instantsearch;
    var algoliasearch = algolia.externals.algoliasearch;
    var searchBox = algolia.externals.widgets.searchBox;
    var stats = algolia.externals.widgets.stats;
    var sortBy = algolia.externals.widgets.sortBy;
    var clearRefinements = algolia.externals.widgets.clearRefinements;
    var panel = algolia.externals.widgets.panel;
    var hits = algolia.externals.widgets.hits;
    var pagination = algolia.externals.widgets.pagination;
    var configure = algolia.externals.widgets.configure;
    var connectCurrentRefinements = algolia.externals.connectors.connectCurrentRefinements;
    var aa = algolia.externals.aa;

    var collectionPageEnabled =
        algolia.is_collection_results_page && algolia.config.instant_search_enabled_on_collection;

    if (!algolia.full_results && !algolia.is_collection_results_page) {
        /**
         * If we aren't on the search page and neither on a collection page,
         * then there's no need to proceed
         */
        return;
    } else if (algolia.full_results) {
        /**
         * If we are on the search page and instant search isn't enabled,
         * then there's no need to proceed
         */
        if (!algolia.config.instant_search_enabled) {
            return;
        }
    } else if (algolia.is_collection_results_page) {
        /**
         * If we are on a collection page and instant search on collection isn't
         * enabled, then there's no need to proceed
         */
        if (!algolia.config.instant_search_enabled_on_collection) {
            return;
        }
    }

    /**
     * Array which will contain all filters to be applied while initiating the
     * search API call.
     */
    var searchFilters = [];

    var collectionFacetFilter = null;
    var collectionRulesContextValue = null;
    var collectionHandle = null;

    if (collectionPageEnabled) {
        var matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
        collectionHandle = Boolean(matches) && matches.length === 2 ? matches[1] : null;

        if (algolia.config.collection_id_indexing) {
            collectionFacetFilter = algolia.current_collection_id
                ? 'collection_ids:"' + algolia.current_collection_id + '"'
                : null;
        } else {
            collectionFacetFilter = 'collections:"' + collectionHandle + '"';
        }

        // Add the collection filter to the list of search filters
        searchFilters.push(collectionFacetFilter);

        collectionRulesContextValue = algolia.config.collection_id_query_rules
            ? algolia.current_collection_id
            : collectionHandle;
    }

    // Filters for stock policy
    var stockPolicyFilter = null;
    if (algolia.config.stock_policy) {
        if (algolia.config.stock_policy === 'allow') {
            /**
             * For 'allow', we don't need to add any filter as we want to continue
             * displaying all out of stock items.
             */
        } else if (algolia.config.stock_policy === 'deny') {
            // For 'deny' we will filter out all items based on inventory quantity
            stockPolicyFilter = 'inventory_quantity > 0';
        } else if (algolia.config.stock_policy === 'continue') {
            /**
             * For 'continue' we will filter on `inventory_available` attribute whose
             * value is dependent on:
             * `inventory_quantity > 0 OR inventory_policy == 'continue'`
             */
            stockPolicyFilter = 'inventory_available:true';
        }

        // Add the stock policy filter to the list of search filters
        if (stockPolicyFilter) {
            searchFilters.push(stockPolicyFilter);
        }
    }

    var results_selector = collectionPageEnabled
        ? algolia.config.collection_css_selector
        : algolia.config.results_selector;

    var activeSortOrders =
        collectionPageEnabled && algolia.collectionSortOrders
            ? algolia.collectionSortOrders
            : algolia.sortOrders;

    results_selector += ', .algolia-shopify-instantsearch';

    function getTrackedUiState(uiState) {
        var trackedUiState = {};
        Object.keys(uiState).forEach(function (k) {
            if (k === 'configure' || k === 'query' || k === 'q') {
                return;
            }
            trackedUiState[k] = uiState[k];
        });
        return trackedUiState;
    }

    /**
     * List of URL params which are "allowed" by InstantSearch.
     * These parameters won't be overwritten when the search state is written
     * to the URL.
     */
    var ALLOWED_FOREIGN_PARAMS = [
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_term',
        'utm_content'
    ];
    var foreignRouteState;

    function singleIndex(indexName) {
        return {
            /**
             * `stateToRoute` method transforms the `uiState` object from InstantSearch
             * into an object that will then be serialized to construct the URL.
             */
            stateToRoute: function (uiState) {
                var route = getTrackedUiState(uiState[indexName] || {});
                route.q = uiState[indexName].query;
                return Object.assign({}, foreignRouteState, route);
            },

            /**
             * `routeToState` method transforms the route object into a `uiState` object
             * so that InstantSearch is initialized with the correct state from the
             * URL.
             */
            routeToState: function (routeState) {
                /**
                 * Backup parameters from `routeState` into a different object
                 * `foreignRouteState` so that we can re-inject them into the object
                 * returned within `stateToRoute`.
                 * This allows us to preserve the parameters specified in `ALLOWED_FOREIGN_PARAMS`
                 * array.
                 */
                if (!foreignRouteState) {
                    foreignRouteState = ALLOWED_FOREIGN_PARAMS.reduce(function (acc, key) {
                        acc[key] = routeState[key];
                        return acc;
                    }, {});
                }

                var state = {};
                state[indexName] = getTrackedUiState(routeState || {});
                state[indexName].query = routeState.q;
                return state;
            }
        };
    }

    var instant = {
        colors: algolia.config.colors,
        distinct: Boolean(algolia.config.show_products),
        facets: {
            hidden:
                collectionPageEnabled && algolia.collectionHiddenFacets
                    ? algolia.collectionHiddenFacets
                    : algolia.hiddenFacets,
            shown:
                collectionPageEnabled && algolia.collectionShownFacets
                    ? algolia.collectionShownFacets
                    : algolia.shownFacets,
            list:
                collectionPageEnabled && algolia.collectionFacets
                    ? algolia.collectionFacets
                    : algolia.facets,
            widgets:
                collectionPageEnabled && algolia.collectionFacetsWidgets
                    ? algolia.collectionFacetsWidgets
                    : algolia.facetsWidgets
        },
        hitsPerPage:
            collectionPageEnabled && algolia.config.collections_full_results_hits_per_page
                ? algolia.config.collections_full_results_hits_per_page
                : algolia.config.products_full_results_hits_per_page,
        poweredBy: algolia.config.powered_by,
        search: instantsearch({
            searchClient: algoliasearch(algolia.config.app_id, algolia.config.search_api_key),
            indexName: algolia.config.index_prefix + 'products',
            routing: {
                stateMapping: singleIndex(algolia.config.index_prefix + 'products')
            },
            searchFunction: function (searchFunctionHelper) {
                // Set query parameters here because they're not kept when someone
                // presses the Back button if set in the `init` function of a custom widget
                var page = searchFunctionHelper.getPage();
                searchFunctionHelper.setQueryParameter(
                    'highlightPreTag',
                    '<span class="ais-highlight">'
                );
                searchFunctionHelper.setQueryParameter('highlightPostTag', '</span>');
                if (instant.distinct) {
                    searchFunctionHelper.setQueryParameter('distinct', true);
                }

                // Assign any required filters
                if (searchFilters.length) {
                    searchFunctionHelper.setQueryParameter('filters', searchFilters.join(' AND '));
                }

                // Assign any required `ruleContexts` which are required for query rules
                // targeting collection pages
                if (collectionPageEnabled) {
                    // Collection page merchandising:
                    // If we are on a collection page, `collectionRulesContextValue` is defined
                    if (collectionRulesContextValue) {
                        searchFunctionHelper.setQueryParameter('ruleContexts', [
                            collectionRulesContextValue.toString()
                        ]);
                    } else {
                        searchFunctionHelper.setQueryParameter('ruleContexts', []);
                    }
                }

                searchFunctionHelper.setPage(page);
                searchFunctionHelper.search();
            }
        }),
        selector: results_selector + ', .algolia-shopify-instantsearch',
        sortOrders: activeSortOrders,
        storeName: algolia.storeName,
        templates: {
            currentItem: algolia.getTemplate('instant_search_current_refined_values_item'),
            empty: algolia.getTemplate('instant_search_no_result'),
            page: algolia.compileTemplate('instant_search'),
            product: algolia.getTemplate('instant_search_product'),
            stats: algolia.getTemplate('instant_search_stats'),
            style: algolia.compileTemplate('instant_search.css')
        }
    };

    algolia.instantsearch = instant;

    if (instant.poweredBy) {
        // eslint-disable-next-line no-console
        console.log('Algolia: Instant-Search');
    }

    function readjust() {
        var width = instant.$results.offsetWidth;

        var suffix = 'lg';
        if (width < 400) suffix = 'xs';
        else if (width < 800) suffix = 'sm';
        else if (width < 1200) suffix = 'md';

        instant.$results.classList.remove('ais-results-size-xs');
        instant.$results.classList.remove('ais-results-size-sm');
        instant.$results.classList.remove('ais-results-size-md');
        instant.$results.classList.remove('ais-results-size-lg');
        instant.$results.classList.add('ais-results-size-' + suffix);
    }

    // Bind helpers
    var helpers = algolia.assign({}, algolia.helpers, algolia.translation_helpers);
    Object.keys(helpers).forEach(function (name) {
        var helper = helpers[name];
        instant.search.templatesConfig.helpers[name] = helper;
    });
    instant.search.templatesConfig.compileOptions = algolia.hoganOptions;

    algolia.appendStyle(
        algolia.render(instant.templates.style, {
            distinct: instant.distinct,
            colors: instant.colors
        })
    );
    let algResult = document.querySelector('.ais-InfiniteHits-item:last-child div');
    const container = document.querySelector('.ais-pagination-container');
    if (
        algolia.full_results ||
        (typeof algResult != 'undefined' &&
            algResult != null &&
            algResult.hasAttribute('data-objectid'))
    ) {
        if (!container) return;
        // Pagination
        instant.search.addWidgets([
            pagination({
                container: '.ais-pagination-container',
                padding: 2,
                maxPages: 20
            })
        ]);
    }

    // Main
    instant.search.start();
    algolia.contentHide.parentNode.removeChild(algolia.contentHide);
})(window.algoliaShopify);
